import { AsyncPipe, DecimalPipe, SlicePipe } from "@angular/common";
import { ChangeDetectorRef, Component, ElementRef, inject, OnDestroy, OnInit, ViewChild } from "@angular/core";
import { AngularFireAnalytics } from "@angular/fire/compat/analytics";
import { MatBottomSheet } from "@angular/material/bottom-sheet";
import { MatDialog } from "@angular/material/dialog";
import { Data, Router } from "@angular/router";
import { AuthService } from "@core/auth.service";
import { AuthPartialRegService } from "@core/AuthServices/authPartialReg/auth-partial-reg.service";
import { isMobile } from "@core/utility.service";
import { IonContent, IonicModule, PopoverController } from "@ionic/angular";
import { TranslatePipe, TranslateService } from "@ngx-translate/core";
import { asyncScheduler, BehaviorSubject, combineLatest, of, Subject } from "rxjs";
import { map, observeOn, takeUntil, tap, withLatestFrom } from "rxjs/operators";
import { bottomSheetSlideUp } from "src/app/animations/custom.animation";
import { CommonVariable, Orientation } from "src/app/app.constants";
import { ComingSoonComponent } from "src/app/components/coming-soon/coming-soon.component";
import { GamePlayComponent } from "src/app/components/game-play/game-play.component";
import { InboxMessageComponent } from "src/app/components/inbox-message/inbox-message.component";
import { WindowsGamePlayPopupComponent } from "src/app/components/windows-game-play-popup/windows-game-play-popup.component";
import { HomeDataService } from "src/app/services/home-data.service";
import { NarratorService } from "src/app/services/narrator.service";
import { NotificationManagerService } from "src/app/services/notification-manager.service";
import { OrientationService } from "src/app/services/orientation.service";
import { TimerService } from "src/app/services/timer.service";
import { TrackedEventsService } from "src/app/services/tracked-events.service";
import type { SwiperOptions } from "swiper/types";
import { SwiperComponent, SwiperModule } from "swiper/angular";
import { InProgressAnimationComponent } from "../../components/in-progress-animation/in-progress-animation.component";
import { TopHeaderComponent } from "../../components/top-header/top-header.component";
import { FilterYoursToPlay } from "../../pipe/yours-to-play/yoursToPlay";
import { HomeRepositoryService } from "../home/home-repository.service";
import { TabRepositoryService } from "../tabs/tab-repository.service";
import { GamesRepositoryService } from "./games-repository.service";
import { GameDatasService } from "./services/game-data.service";
import { GamePlayService } from "./services/game-play.service";
import { GameRecommendationService } from "./services/game-recommendation.service";
import { GameStreamsService } from "./services/game-streams.service";
import { GamePreDetailsPopupComponent } from "./yours-to-play-popup/yours-to-play-popup.component";

@Component({
  selector: "app-games",
  templateUrl: "./games.page.html",
  styleUrls: ["./games.page.scss"],
  animations: [bottomSheetSlideUp],
  standalone: true,
  imports: [
    TopHeaderComponent,
    IonicModule,
    InProgressAnimationComponent,
    SwiperModule,
    AsyncPipe,
    SlicePipe,
    DecimalPipe,
    FilterYoursToPlay,
    TranslatePipe,
  ],
})
export class GamesPage implements OnInit, OnDestroy {
  private orientationService = inject(OrientationService);
  public popoverController = inject(PopoverController);
  private router = inject(Router);
  private gameService = inject(GamesRepositoryService);
  private analytics = inject(AngularFireAnalytics);
  private authService = inject(AuthService);
  private bottomSheet = inject(MatBottomSheet);
  private tabService = inject(TabRepositoryService);
  private homeRepositoryService = inject(HomeRepositoryService);
  private timerService = inject(TimerService);
  public translate = inject(TranslateService);
  private trackedEventsService = inject(TrackedEventsService);
  private matDialog = inject(MatDialog);
  private AuthPartialRegService = inject(AuthPartialRegService);
  private homeDataService = inject(HomeDataService);
  private narratorService = inject(NarratorService);
  private notificationManagerService = inject(NotificationManagerService);
  private changeDetectorRef = inject(ChangeDetectorRef);
  private gameStreamsService = inject(GameStreamsService)
  private gameRecommendationService = inject(GameRecommendationService)
  private gameDatasService = inject(GameDatasService)
  private gamePlayService = inject(GamePlayService)

  private destroy$ = new Subject<void>();

  showToolTip$ = new BehaviorSubject(true);
  @ViewChild("1") elementView: ElementRef;
  @ViewChild("pageTop") pageTop: IonContent;
  @ViewChild("YoursToPlaySlider") sliderOne: SwiperComponent;
  @ViewChild("yoursloveGameSlider") sliderTwo: SwiperComponent;
  @ViewChild("adventureGameSlide") sliderThree: SwiperComponent;
  @ViewChild("instantWinSlide") sliderFour: SwiperComponent;
  @ViewChild("skilledGameSlider") sliderFive: SwiperComponent;
  gameToolTip = this.homeRepositoryService?.toolTipText$;
  //yourToPlayRecomandation$ = this.gameService?.yourToPlayGame$;
  user$ = this.authService?.userDetails$;

  listOfAdvImg = [];
  currentInProgressAdvId = null;
  gameOrientation: Orientation;
  isAdventureLocked = false;
  slideOpts: SwiperOptions = {
    initialSlide: 0,
    slidesPerView: 1.25,
    spaceBetween: 20,
    centeredSlides: false,
    slidesOffsetBefore: 20,
    slidesOffsetAfter: 20,
    speed: 400,
    autoplay: false,
    pagination: {
      el: ".swiper-pagination-one",
      clickable: true,
    },
  };

  y2pslideOpts: SwiperOptions = {
    initialSlide: 0,
    slidesPerView: 3.7,
    spaceBetween: 20,
    centeredSlides: false,
    speed: 400,
    autoplay: false,
    pagination: {
      el: ".swiper-pagination_",
      clickable: true,
    },
  };

  public adventureSlide: SwiperOptions = {
    initialSlide: 0,
    slidesPerView: 1.25,
    spaceBetween: 20,
    centeredSlides: false,
    slidesOffsetBefore: 20,
    slidesOffsetAfter: 20,
    speed: 400,
    autoplay: false,
    pagination: {
      el: ".swiper-pagination-two",
      clickable: true,
    },
  };
  public instantWinSlider: SwiperOptions = {
    initialSlide: 0,
    slidesPerView: 1.25,
    spaceBetween: 20,
    centeredSlides: false,
    slidesOffsetBefore: 20,
    slidesOffsetAfter: 20,
    speed: 400,
    autoplay: false,
    pagination: {
      el: ".swiper-pagination-four",
      clickable: true,
    },
  };
  public SkilledgameslideOpts: SwiperOptions = {
    initialSlide: 0,
    slidesPerView: 1.25,
    spaceBetween: 20,
    centeredSlides: false,
    slidesOffsetBefore: 20,
    slidesOffsetAfter: 20,
    speed: 400,
    autoplay: false,
    pagination: {
      el: ".swiper-pagination-three",
      clickable: true,
    },
  };
  // End
  expandBottomSlider = false;
  gameSlider = [];
  sliderCount = 0;
  isAdventureCompleted: boolean = false;
  showView = false;

  gamesSlide$ = this.gameStreamsService?.gameTopSlider$;

  // LOTTOSOCIAL-PWA-1NC5: The previous implementation mutated this.showTT inside
  // map(), which is a synchronous side effect during Angular's change detection cycle.
  // Zone.js detected the property write, marked the component dirty, and scheduled
  // another CD run synchronously — re-entering the same cycle and causing a stack
  // overflow. The fix: return a pure boolean; drive the template @if directly from
  // the async pipe and control show/hide via showToolTip$ in openTT().
  show$ = combineLatest(this.authService?.userDetails$, this.showToolTip$)?.pipe(
    map(([user, toolTip]: any) => {
      return !!(user && user?.onboard_state === "awareness" && toolTip);
    })
  );

  instantWins$ = this.gameStreamsService?.instantWinGames$?.pipe(
    map((instantGames: any) => {
      if (!instantGames || !instantGames?.games) {
        return;
      }
      instantGames?.games.map((game, index) => {
        if (!game) return;

        try {
          const defaultCurrency = 44;
          game["cc"] = defaultCurrency;
          if (game?.int_top_prize) {
            this.authService
              .getDVFromString(game?.int_top_prize[this.languageCode])
              .then((resp: string) => {
                instantGames.games[index].gameTopPrice = resp;
              })
              .catch((err) => {
                return err;
              });
          } else if (game?.top_prize) {
            this.authService
              .getDVFromString(game.top_prize)
              .then((resp: string) => {
                instantGames.games[index].gameTopPrice = resp;
              })
              .catch((err) => {
                return err;
              });
          } else {
            instantGames.games[index].gameTopPrice =
              game?.country_code_data?.[
                this.preferredCurrency == "CAD" ? 1 : this.preferredCurrency == "EUR" ? 353 : 44
              ]?.top_prize;
          }
          if (game?.int_game_short_title) {
            this.authService
              .getDVFromString(game.int_game_short_title[this.languageCode])
              .then((resp: string) => {
                instantGames.games[index].gameShortTitle = resp;
              })
              .catch((err) => {
                return err;
              });
          } else if (game?.game_short_title) {
            this.authService
              .getDVFromString(game.game_short_title)
              .then((resp: string) => {
                instantGames.games[index].gameShortTitle = resp;
              })
              .catch((err) => {
                return err;
              });
          } else {
            const countryCode = this.preferredCurrency == "CAD" ? 1 : this.preferredCurrency == "EUR" ? 353 : 44;
            instantGames.games[index].gameShortTitle = game?.country_code_data[countryCode]?.game_short_title;
          }

          if (game?.int_game_popup_details) {
            this.authService
              .getDVFromString(game.int_game_popup_details[this.languageCode])
              .then((resp: string) => {
                instantGames.games[index].intGamePopupDetails = resp;
              })
              .catch((err) => {
                return err;
              });
          } else if (game?.game_popup_details) {
            this.authService
              .getDVFromString(game.game_popup_details)
              .then((resp: string) => {
                instantGames.games[index].intGamePopupDetails = resp;
              })
              .catch((err) => {
                return err;
              });
          } else {
            const countryCode = this.preferredCurrency == "CAD" ? 1 : this.preferredCurrency == "EUR" ? 353 : 44;
            instantGames.games[index].intGamePopupDetails = game?.country_code_data[countryCode]?.game_popup_details;
          }
        } catch (e) {
          return e;
          // console.log(e);
        }
      });
      return instantGames;
    })
  );
  // LOTTOSOCIAL-PWA-1NC5: Derive advId/allIds/data in a single pure map() with no
  // component-state mutations. Then observeOn(asyncScheduler) shifts the downstream
  // tap() onto a macrotask, so this.advId / this.allIds are written outside Angular's
  // synchronous change-detection pass — eliminating the re-entrant Zone.js scheduling
  // that previously contributed to the call-stack overflow.
  //
  // Note: advId == null guards against falsy-but-valid IDs (e.g. numeric 0).
  userAdventure$ = this.gameStreamsService?.adventure$?.pipe(
    map((d: any) => {
      const games: any[] | undefined = d?.games;
      const ids: any[] = games?.map((g: any) => g?.adventure_id) ?? [];
      const advId = games?.find(
        (a: any) => a?.userAdventure?.adventure_mod?.toLowerCase() === "inprogress"
      )?.adventure_id;

      let allIds: any[];
      let data: any = d;
      if (games == null || advId == null) {
        // No active in-progress adventure; expose all ids.
        allIds = ids;
      } else {
        const index = ids.length ? ids.indexOf(advId) : -1;
        if (index === -1) {
          allIds = [];
          data = undefined;
        } else {
          allIds = ids.slice(0, index);
        }
      }
      return { data, advId, allIds };
    }),
    observeOn(asyncScheduler),
    tap(({ advId, allIds }: { data: any; advId: any; allIds: any[] }) => {
      this.advId = advId;
      this.allIds = allIds;
    }),
    map(({ data }: { data: any; advId: any; allIds: any[] }) => data)
  );
  userYoursToPlay$ = this.gameStreamsService?.yoursToPlay$?.pipe(
    map((games: any[]) => {
      games.map((game) => {
        if (!game) return;

        try {
          const defaultCurrency = 44;
          game["cc"] = defaultCurrency;
          const gameTitle = game.details?.game_title;
          /* if(recommendationGame.details.int_game_title){

     } else  */ if (gameTitle) {
            this.authService
              .getDVFromString(gameTitle)
              .then((resp: string) => {
                game.details.game_title = resp;
              })
              .catch((err) => {
                return err;
              });
          } else {
            const countryCode = this.preferredCurrency == "CAD" ? 1 : this.preferredCurrency == "EUR" ? 353 : 44;
            game.details.game_title = game?.details?.country_code_data[countryCode]?.game_title;
          }
        } catch (e) {
          return e;
          // console.log(e);
        }

        // game["cc"] =
        //   CommonVariable?.countryCode === "" || CommonVariable?.countryCode === "IN" ? 44 : CommonVariable?.countryCode;
      });
      return games?.filter((res) => res?.category != "prototype");
    })
  );

  yourToPlayRecomandation$ = this.gameRecommendationService?.yourToPlayGame$?.pipe(
    map((recommendations: Data) => {
      const isEmpty = (val: any) => val === undefined || val === null || !(Object.keys(val) || val).length;
      try {
        if (!isEmpty(recommendations)) {
          recommendations.map((recommendationGame) => {
            const gameTitle = recommendationGame.gameData.game_title;
            const gameShortTitle = recommendationGame.gameData.game_short_title;
            const gameTopPrize = recommendationGame.gameData.top_prize;
            const gameTotalPrize = recommendationGame.gameData.total_prize;
            /*  if(recommendationGame.gameData.int_game_short_title){
      } else */ if (gameShortTitle) {
              this.authService
                .getDVFromString(gameShortTitle)
                .then((resp: string) => {
                  recommendationGame.gameData.game_short_title = resp;
                })
                .catch((err) => {
                  return err;
                });
            } else {
              const countryCode = this.preferredCurrency == "CAD" ? 1 : this.preferredCurrency == "EUR" ? 353 : 44;
              recommendationGame.gameData.game_short_title =
                recommendationGame?.gameData?.country_code_data[countryCode]?.game_short_title;
            }

            /* if(recommendationGame.gameData.int_game_title){

      } else  */ if (gameTitle) {
              this.authService
                .getDVFromString(gameTitle)
                .then((resp: string) => {
                  recommendationGame.gameData.game_title = resp;
                })
                .catch((err) => {
                  return err;
                });
            } else {
              const countryCode = this.preferredCurrency == "CAD" ? 1 : this.preferredCurrency == "EUR" ? 353 : 44;
              recommendationGame.gameData.game_title =
                recommendationGame?.gameData?.country_code_data[countryCode]?.game_title;
            }

            /* if(recommendationGame.gameData.int_top_prize){

      } else  */ if (gameTopPrize) {
              this.authService
                .getDVFromString(gameTopPrize)
                .then((resp: string) => {
                  recommendationGame.gameData.top_prize = resp;
                })
                .catch((err) => {
                  return err;
                });
            } else {
              const countryCode = this.preferredCurrency == "CAD" ? 1 : this.preferredCurrency == "EUR" ? 353 : 44;
              recommendationGame.gameData.top_prize =
                recommendationGame?.gameData?.country_code_data[countryCode]?.top_prize;
            }

            /* if(recommendationGame.gameData.int_total_prize){

      } else  */ if (gameTotalPrize) {
              this.authService
                .getDVFromString(gameTotalPrize)
                .then((resp: string) => {
                  recommendationGame.gameData.total_prize = resp;
                })
                .catch((err) => {
                  return err;
                });
            } else {
              const countryCode = this.preferredCurrency == "CAD" ? 1 : this.preferredCurrency == "EUR" ? 353 : 44;
              recommendationGame.gameData.total_prize =
                recommendationGame?.gameData?.country_code_data[countryCode]?.total_prize;
            }
          });
        }
        return recommendations;
      } catch (err) {
        return err;
        //console.log("Err", err)
      }
    })
  );

  skillGames$ = this.gameStreamsService.skillGames$?.pipe(
    map((skillGames: any) => {
      if (!skillGames || !skillGames?.games) {
        return;
      }
      skillGames.games.map((game) => {
        if (!game) return;

        try {
          const defaultCurrency = 44;
          game["cc"] = defaultCurrency;
          const gameTitle = game.game_title;
          const gameShortTitle = game.game_short_title;
          const gameTotalPrize = game.total_prize;

          /*  if(recommendationGame.gameData.int_game_short_title){
      } else */ if (gameShortTitle) {
            this.authService
              .getDVFromString(gameShortTitle)
              .then((resp: string) => {
                game.game_short_title = resp;
              })
              .catch((err) => {
                return err;
              });
          } else {
            const countryCode = this.preferredCurrency == "CAD" ? 1 : this.preferredCurrency == "EUR" ? 353 : 44;
            game.game_short_title = game?.country_code_data[countryCode]?.game_short_title;
          }

          /* if(game.int_game_title){

      } else  */ if (gameTitle) {
            this.authService
              .getDVFromString(gameTitle)
              .then((resp: string) => {
                game.game_title = resp;
              })
              .catch((err) => {
                return err;
              });
          } else {
            const countryCode = this.preferredCurrency == "CAD" ? 1 : this.preferredCurrency == "EUR" ? 353 : 44;
            game.game_title = game?.country_code_data[countryCode]?.game_title;
          }

          /* if(game.int_total_prize){

      } else  */ if (gameTotalPrize) {
            this.authService
              .getDVFromString(gameTotalPrize)
              .then((resp: string) => {
                game.total_prize = resp;
              })
              .catch((err) => {
                return err;
              });
          } else {
            const countryCode = this.preferredCurrency == "CAD" ? 1 : this.preferredCurrency == "EUR" ? 353 : 44;
            game.total_prize = game?.country_code_data[countryCode]?.total_prize;
          }
        } catch (e) {
          return e;
          //console.log(e);
        }
      });
      return skillGames;
    })
  );

  errorImage(img: any) {
    if (!img || !img.el || !img.el?.style) return;
    img.src = "this.src='../../../assets/images/usericon_profile_signup.svg";
    img.el.style.background = "white";
    img.el.style.padding = "2vh";
  }

  userBalanceDetails$ = this.authService?.userCurrentBalance$.pipe(
    withLatestFrom(this.authService?.userDetails$),

    map((data: any) => {
      try {
        return { ...data[0], ...data[1] };
      } catch (e) {
        return e;
      }
    })
  );

  recommendations$ = this.gameRecommendationService?.recommendationsGames$?.pipe(
    map((recGame: any) => {
      recGame?.map((game) => {
        if (!game) return;

        try {
          const defaultCurrency = 44;
          game["cc"] = defaultCurrency;
        } catch (e) {
          return e;
          //console.log(e)
        }
      });
      return recGame;
    })
  );
  internetMessage: any = "test message sir";
  inProgress: any;
  inProgressQuit: boolean;
  advId: any;
  allIds: any;
  selectedLanguage: string = "en";
  starDisplay = "Fruit Loose";
  prizeUnlockID: any;
  translatedToastMsg: any;
  preferredCurrency: string = CommonVariable.preferredCurrency;
  currencySymbol: string = CommonVariable.defaultCurrencySymbol;
  public languageCode: string;
  userId: string;
  constructor() {
    this.languageCode = "en";
    try {
      this.authService?.selectedlanguage$?.subscribe(
        (l) => {
          this.selectedLanguage = l ? l : "en";
          if (l) {
            this.translate.use(l ? l : "en");
          }
        },
        (err) => {
          return err;
        }
      );
      this.authService?.getConstantsMsg$?.subscribe((msg: any) => {
        this.translatedToastMsg = msg?.static_messages_pwa;
      });

      this.authService?.userDetails$?.subscribe(
        (user: any) => {
          this.preferredCurrency = user?.preferred_currency ?? CommonVariable.preferredCurrency;
          this.authService.getCurrencyList$?.subscribe((data: any) => {
            const CurrencyDetails = data?.details?.find((x: any) => x?.currency_code === this.preferredCurrency);
            this.currencySymbol =
              CurrencyDetails?.currency_symbol ?? CommonVariable.defaultCurrencySymbol;
          });
        },
        (err) => {
          return err;
        }
      );
    } catch (e) {
      return e;
    }
  }

  async ngOnInit() {
    await this.authService
      ?.getUid("GamePage")
      ?.then((uid) => {
        this.userId = uid;
      })
      .catch((error) => {
        return error;
      });
    this.authService?.userDetails$?.subscribe((user: Data) => {
      this.languageCode = user?.language_code ? user?.language_code : "en";
      this.translate.use(this.languageCode);
    });
    try {
      this.gameStreamsService.prizeUnlock$?.subscribe((data) => {
        this.prizeUnlockID = data;
      });
    } catch (e) {
      return e;
    }
    this.tabService?.selectGameTab();

    try {
      this.analytics.logEvent("games_screen", {
        userId: this.userId,
      });
    } catch (e) {
      return e;
    }

    this.showInboxMessage();
    try {
      this.gameService?.internetSpeed$?.subscribe(
        (data) => {
          if (!data) {
            this.internetMessage = null;
          } else if (data === "slow") {
            setTimeout(() => {
              this.internetMessage = null;
            }, 5000);
            this.internetMessage = "Internet connection too poor to play, improve your connect and try again.";
          }
        },
        (err) => {
          return err;
        }
      );
    } catch (e) {
      return e;
    }
  }

   public narratorData: Data; 
     public narratorShow(): void {
       this.narratorService
         ?.getNarratorTipsHome()
         .pipe(takeUntil(this.destroy$))
         .subscribe(
           (response: Data[]) => {
             this.narratorData = [] as Data;
             if (Array.isArray(response) && response.length > 0) {
               const current = this.narratorService?.getCurrentPageURL();
               const pageName = current?.includes("?") ? current.split("?")[0] : current;
               for (const tip of response) {
                 if (tip?.setting?.page_name === pageName && tip?.setting?.seen === false) {
                   localStorage.setItem("narratorID", tip?.id);
                   this.narratorData = tip;
                   break;
                 }
               }
             }
             if (
               this.narratorData?.setting?.seen === false &&
               (() => {
                 const current = this.narratorService?.getCurrentPageURL();
                 const pageName = current?.includes("?") ? current.split("?")[0] : current;
                 return this.narratorData?.setting?.page_name === pageName;
               })()
             ) {
               this.notificationManagerService.addNotification(
                 { ...this.narratorData, type: "narrator_tip" }
               );
             }
           },
           (error) => { this.authService.errorHandlerLogs("narratorDataError", error); }
         );
     }

  getImgSrc(games, id, adventure_id, index) {
    // Derive in-progress adventure from the games list — do not rely on component
    // fields mutated from an observable (LOTTOSOCIAL-PWA-1NC5 CD re-entry).
    const advId = games?.find(
      (a) => a?.userAdventure?.adventure_mod?.toLowerCase() === "inprogress"
    )?.adventure_id;
    if (!advId) {
      if (games[index]?.adventure_id !== adventure_id) {
        return games[index]?.adventure_icon_url;
      }
      return null;
    }
    return games?.find((g) => g?.adventure_id === id)?.adventure_icon_url;
  }

  hideInternetSpeedMsg() {
    this.internetMessage = null;
  }

  private showInboxMessage() {
    setTimeout(() => {
      if (!this.showView) {
        this.showView = true;
        try {
          this.homeDataService?.userInbox$
            ?.pipe(
              map((data: any) => {
                if (!data || !data?.length) return;
                data = data.filter((values: any) => {
                  return (
                    values?.auto_show &&
                    !values.viewed &&
                    (values?.auto_show_inbox_page === "game" || values?.auto_show_inbox_page === "all")
                  );
                });
                return data;
              })
            )
            ?.subscribe(
              (data: Data[]) => {
                if (!data || !data?.length) return of({});
                try {
                  if (data[0]) {
                    data[0].viewed = true;
                    if (data[0]?.inbox_template) {
                      // The openTemplate() is used to open the inbox template component
                      this.AuthPartialRegService?.openTemplate(data[0]);
                    } else {
                      this.openMessage(data[0]);
                    }
                  }
                } catch (e) {
                  return e;
                }
              },
              (err) => {
                return err;
              }
            );
        } catch (e) {
          return e;
        }
      }
    }, 5000);
  }

  async openPopup(event: any, game?: any, y2p?: string) {
    // if (!game || !game.details) return;
    if (y2p) {
      game = { ...game?.details, ...game };
      this.gameDatasService?.setY2PGameData({ ...game, section: "y2p" });
      // this.gameService.selectedYoursToPlay$.next(game);
    } else {
      this.gameDatasService?.setY2PGameData(null);
      // this.gameService.selectedYoursToPlay$.next(null);
    }

    if (event.pageX >= 150) {
      try {
        const popover = await this.popoverController.create({
          component: GamePreDetailsPopupComponent,
          event,
          translucent: true,
          mode: "ios",
          cssClass: "yours-to-play-popup right-game-tooltip-popover",
          componentProps: { data: { ...game, ...{ isY2p: y2p } } },
        });
        popover.onDidDismiss().then((dataReturned) => {
          if (dataReturned !== null && dataReturned?.data) {
            this.goToGamePlay(dataReturned?.data, y2p);
          }
        }).catch((error) => {
          return error;
        });
        return await popover.present();
      } catch (e) {
        return e;
      }
    } else {
      try {
        const popover = await this.popoverController.create({
          component: GamePreDetailsPopupComponent,
          event,
          translucent: true,
          mode: "ios",
          cssClass: "yours-to-play-popup",
          componentProps: { data: { ...game, ...{ isY2p: y2p } } },
        });
        popover.onDidDismiss().then((dataReturned) => {
          if (dataReturned !== null && dataReturned?.data) {
            this.goToGamePlay(dataReturned?.data, y2p);
          }
        }).catch((error) => {
          return error;
        });
        return await popover.present();
      } catch (e) {
        return e;
      }
    }
  }

  gameBlog(index) {
    this.router.navigateByUrl(`games/game-blog/${index}`);
  }

  public pageScroller(pageTop: IonContent) {
    //scroll to page top
    if (!this.pageTop && pageTop) {
      this.pageTop = pageTop;
    } else if (!this.pageTop && !pageTop) {
      return;
    } else {
      this.pageTop?.scrollToTop();
    }
  }

  goToGamePlay(game: any, y2p?: string) {
    let isUpdatedCelebration = false;

    if (y2p && game && game?.category?.toLowerCase() === "prize unlock") {
      this.router.navigateByUrl(`games/skill-game/${game?.game_id}?y2p=1`);
      return;
    }

    game && game?.category && game?.category?.toLowerCase() === "instant win"
      ? this.goToInstantGame(game)
      : this.goToSkillGame(game);
  }

  goToInstantGame(game: any) {
    this.router.navigateByUrl(`games/instant-win-game/${game?.game_id}`);
  }

  goToSkillGame(game: any) {
    if (game?.game_type_id === 4 || game?.game_type_id === 2) {
      this.router.navigateByUrl(`games/skill-game/${game?.game_id}`);
    } else if (game?.game_type_id === 10) {
      this.router.navigateByUrl(`games/replayable/${game?.game_id}`);
    }
    //if 10 then replayable
    //if 4 then chapter
    //if 2 then chapter
  }

  getProgressPercentage(gameBadges) {
    try {
      let total = 0;
      gameBadges.map((gameBadge) => {
        total += +gameBadge?.percentage_completed;
      });
      return total / (gameBadges.length * 100);
    } catch (e) {
      return e;
    }
  }

  slideChanged() {
    this.gameSlider?.forEach((slide, index) => {
      if (index < this.sliderCount) {
        this.gameSlider?.push(slide);
      }
    });
  }

  openMessage(message) {
    const panelClass =
      message?.template_type === "plunko_christmas" || message?.template_type === "valentine_plunko_campaign"
        ? "bottom-sheet-fullscreen"
        : "inbox-bottom-sheet";
    const showMessage = this.bottomSheet.open(InboxMessageComponent, {
      panelClass: panelClass,
      data: message,
    });
  }

  upCard() {
    const cardid = document.getElementById("bottomCard");
    if (!cardid || !cardid?.classList) return;
    cardid?.classList?.add("card-up");
    cardid?.classList?.remove("card-down");
  }

  downCard() {
    const cardid = document.getElementById("bottomCard");
    if (!cardid || !cardid?.classList) return;
    cardid?.classList?.add("card-down");
    cardid?.classList?.remove("card-up");
  }

  showPosition() {
    const x = this.elementView.nativeElement.getBoundingClientRect();
  }

  getLocalTimeString(adventure: Data) {
    try {
      return this.timerService.countDownTime(adventure?.userAdventure?.prize_details?.end_date.toDate());
    } catch (error) {
      return error;
    }
  }

  touch() {
    this.showToolTip$.next(false);
  }

  startAdventure(adventure: any) {
    adventure.inProgress = true;
    this.playGame(adventure);

    let eventName;
    let isUpdatedCelebration = false;
    if (adventure?.adventure_id === 3) {
      eventName = "play_adventure_tap";
    }
    if (adventure?.adventure_id === 6) {
      eventName = "play_adventure_action";
    }
    try {
      this.trackedEventsService?.listOfEvents$?.subscribe(
        (d) => {
          d.some((f) => f?.id === eventName) ? this.trackedEventsService?.updateTrackedUserEvent(eventName) : null;
        },
        (err) => {
          return err;
        }
      );
    } catch (e) {
      return e;
    }
    try {
      this.trackedEventsService.listOfEvents$?.subscribe(
        (d) => {
          d.map((data: any) => {
            if (data?.id === eventName && !isUpdatedCelebration) {
              this.trackedEventsService?.updateCelebration(data);
              isUpdatedCelebration = true;
            }
          });
        },
        (err) => {
          return err;
        }
      );
    } catch (e) { }
  }

  playGame(game: any) {
    this.gameOrientation = game?.orientation as Orientation;
    if (!isMobile.any() && game?.orientation == "landscape") {
      this.matDialog.open(WindowsGamePlayPopupComponent);
      return null;
    }
    game.document = "/api_post_request/customer_game_token_authentication";
    game.from_page = "games";
    this.gamePlayService
      .getUserGameInfo(game)
      .then((data: string) => {
        game.inProgress = false;
        this.openPlayGame(data);
      })
      .catch((data) => {
        this.inProgress = false;
        //this.authService.showToast(data?.message ? data?.message : "Something went wrong!", "Error", "");
        try {
          const translatedMsg = {
            message: {
              line_1: data?.message,
              line_2: "",
            },
            style: {
              duration: 2000,
              icon: "tick circle error.svg",
              type: "Error",
            },
          };
          const defaultMsg = {
            message: {
              line_1: "Something went wrong!",
              line_2: "",
            },
            style: {
              type: "Error",
              icon: "tick circle error.svg",
            },
          };
          this.authService?.showToastMessage(translatedMsg, defaultMsg);
          return data;
        } catch (e) {
          return e;
        }
      });
  }

  private async openPlayGame(res: any) {
    try {
      if (isMobile.Android()) {
        this.orientationService?.enterFullscreen();
        this.orientationService?.lockOrientation(this.gameOrientation);
      }
      const dialog = this.matDialog?.open(GamePlayComponent, {
        height: "100%",
        width: "100%",
        data: { data: res },
      });
      dialog.afterClosed()?.subscribe(
        () => {
          this.trackedEventsService.openAnimation();
        },
        (err) => {
          return err;
        }
      );
    } catch (e) {
      return e;
    }
  }
  showMessagePopup() {
    this.matDialog.open(ComingSoonComponent);
  }
  // quiteAdventure(adventureId: any) {
  //   this.inProgressQuit = true;
  //   this.gameService.quitAdventure(adventureId).subscribe((d) => {
  //     this.inProgressQuit = false;
  //     if (d && d.response && d.response.status.toLowerCase() === "success") {
  //       this.snackService.openSnackBar("Successfully quit the adventure", "", "Success", "Success");
  //     } else {
  //       this.snackService.openSnackBar("Something went wrong", "", "Error", "Error");
  //     }
  //   });
  // }

  // closeTooltip() {
  //   let tooltip = document.getElementById("tooltip-wrapper");
  //   tooltip?.classList?.add("tooltip-close");
  //   let tooltipOverlay = document.getElementById("tooltip-overlay");
  //   tooltipOverlay.style.display = "none"
  // }

  openAdventureDetails(adventure_id: any) {
    this.router.navigateByUrl(`games/adventure-game/${adventure_id}`);
  }

  prev(prams) {
    try {
      if (prams === "yourPlay") {
        this.sliderOne?.swiperRef?.slidePrev(500);
      }
      if (prams === "yoursloveGame") {
        this.sliderTwo?.swiperRef?.slidePrev(500);
      }
      if (prams === "adventureGame") {
        this.sliderThree?.swiperRef?.slidePrev(500);
      }
      if (prams === "instantWin") {
        this.sliderFour?.swiperRef?.slidePrev(500);
      }
      if (prams === "skilledGame") {
        this.sliderFive?.swiperRef?.slidePrev(500);
      }
    } catch (e) { }
  }
  next(prams) {
    try {
      if (prams === "yourPlay") {
        this.sliderOne?.swiperRef?.slideNext(500);
      }
      if (prams === "yoursloveGame") {
        this.sliderTwo?.swiperRef?.slideNext(500);
      }
      if (prams === "adventureGame") {
        this.sliderThree?.swiperRef?.slideNext(500);
      }

      if (prams === "instantWin") {
        this.sliderFour?.swiperRef?.slideNext(500);
      }
      if (prams === "skilledGame") {
        this.sliderFive?.swiperRef?.slideNext(500);
      }
    } catch (e) { }
  }
  openTT() {
    // LOTTOSOCIAL-PWA-1NC5: Toggle the reactive source (showToolTip$) rather than
    // the now-removed showTT field, so the template @if (show$ | async) reacts correctly.
    this.showToolTip$.next(!this.showToolTip$.value);
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
